import React, { PropsWithChildren, useEffect, useState } from 'react';
import { AuthJSONClient, AuthJsonProvider as Provider } from '@rahtab/auth/lib';
import { Platform } from 'react-native';
import axios from 'axios';

const BASE_URL_TEST_SERVER = 'https://rahtab.net';
const BASE_URL = 'https://rahtab.net';

export const client = new AuthJSONClient();

export default function AuthJsonProvider({ children }: PropsWithChildren<{}>) {
  const [baseUrl, setBaseUrl] = useState<string | null>(null);
  const providerUrl = `${baseUrl}/DL/Rahtab/ProviderMobileApp.aspx`;
  const middlemanUrl = `${baseUrl}/DL/Rahtab/MiddlemanMobileApp.aspx`;
  useEffect(() => {
    (async () => {
      try {
        if (process.env.NODE_ENV === 'development') {
          setBaseUrl(BASE_URL_TEST_SERVER);
        } else if (Platform.OS === 'web') {
          setBaseUrl('');
        } else {
          const { data: serverAddress, status } = await axios.get<string>(
            'https://rahtab.net/dl/RahtabDispatcher/GetServerAddress.aspx',
            {
              timeout: 5000,
              headers: {
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cache',
                Expires: '0',
              },
            },
          );
          console.log('server address: ', serverAddress, status);
          setBaseUrl(`http://${serverAddress}`);
        }
      } catch (e) {
        setBaseUrl(BASE_URL);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (baseUrl === null) return null;
  return (
    <Provider baseURL={{ 1: providerUrl, 2: middlemanUrl }} roleVersion="multi" client={client}>
      {children}
    </Provider>
  );
}
